'use client';

import { isPublicRoute } from '@workspace/ui/lib';
import { X } from 'lucide-react';
import { usePathname, useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { logout } from '@/actions/mixed/auth';
import { PUBLIC_ROUTES } from '@/config/routes';
import { useAuthStore } from '@/stores/authStore';
import { useWizardStore } from '@/stores/wizardStore';

export default function WizardHeaderX() {
  const router = useRouter();
  const pathname = usePathname();
  const t = useTranslations();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toggleExitDialog = useWizardStore((s) => s.toggleExitDialog);

  const handleClick = useCallback(async () => {
    if (isSubmitting) return;

    // If in add-employee wizard, open the exit dialog
    if (pathname.includes('add-employee')) {
      toggleExitDialog(true);
      return;
    }
    if (
      pathname.includes('add-team-member') ||
      pathname.includes('add-individual-contractor') ||
      pathname.includes('add-company-contractor')
    ) {
      router.push('/people');
      return;
    }

    if (isPublicRoute(PUBLIC_ROUTES, pathname)) {
      if (isAuthenticated) {
        // If user created an organization and the pathname includes 'sign-up'
        // we need to redirect to the dashboard
        const user = useAuthStore.getState().user;

        if (pathname.includes('sign-up') && user?.organisations?.[0]) {
          window.location.href = '/';
          return;
        }

        try {
          setIsSubmitting(true);
          await logout();
          localStorage.removeItem('onboarding_check_completed');
        } catch {
          toast.error(t('toast.logoutError'));
        } finally {
          setIsSubmitting(false);
        }
      }
      window.location.href = process.env.NEXT_PUBLIC_FE_URL_AUTH!;
    } else {
      router.push('/');
    }
  }, [isAuthenticated, isSubmitting, pathname, router, t, toggleExitDialog]);

  return (
    <button
      aria-label="Close"
      onClick={handleClick}
      className="cursor-pointer"
      disabled={isSubmitting}
    >
      <X size={38} className="text-grey-800 dark:text-grey-100" />
    </button>
  );
}
